import React, { useEffect, useState } from "react";
 
import PrevHeader from "./Header";
import { Link, useNavigate, useParams } from "react-router-dom";
import SvgExploreComponent from "../../assets/SVG/Explore1";
import SvgRankComponent from "../../assets/SVG/rank5";

import { ExplorerTabs } from "./hooks/types";
import { useWallet } from "./hooks/content";
import LootboxPageTWO from "./LootboxPageCopy";
import TownesquareAvatar from "./TSAvatar";
import TownesquareMainAvatar from "./MainAvatar";
import Tslogin from "./Tsconnect";
import { EpochFlow } from "./Onboard";

 

const LootboxPage = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [pfpImage, setPfpImage] = useState<string | null>(null);
  const [isEpochnOpen, setisEpochnOpen] = useState(false);
  const { tab } = useParams();
  const { pubAddress, setPubAddress, connectedWallet } = useWallet();
  const [showLoginModal, setShowLoginModal] = useState(false);
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState<ExplorerTabs | string>(
    "townsquare-avatar"
  );

  const handleOConnect = () => {
    setShowLoginModal(true);
  };

  const handleOfConnect = () => {
    setShowLoginModal(false);
  };

  const handleCloseModal = () => {
    setisEpochnOpen(false);
  };

  const disconnectWallet = () => {
    setPubAddress(null);
    sessionStorage.removeItem("walletType");
    sessionStorage.removeItem("userDetails");
    sessionStorage.removeItem("pubAddress");
  };

  useEffect(() => {
    if (pubAddress) {
      setShowLoginModal(false);
    } else {
      setShowLoginModal(false);
    }
  }, [pubAddress]);

  const handleDownload = (imageUrl: string) => {
    const link = document.createElement("a");
    link.href = imageUrl;
    link.download = "nft-image.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const storedPfp = localStorage.getItem("pfpImage");
    if (storedPfp) {
      setPfpImage(storedPfp);
    }
  }, []);

  const handleSetPFP = () => {
    if (selectedImage) {
      setPfpImage(selectedImage);
      localStorage.setItem("pfpImage", selectedImage);
      setSelectedImage(null);
    }
  };

  return (
    <div className="flex min-h-screen text-white bg-black">
      {/* Sidebar */}
      <aside className="w-[244px] z-30 fixed h-screen bg-[#121212] p-[22px] hidden md:flex flex-col justify-between">
        <div>
          <div className="flex items-center mt-4 w-[166px]">
            <Link to="/">
              <img src="/assets/main_v4/theloggo.svg" alt="Townesquare logo" />
            </Link>
          </div>
          <img src="/assets/main_v4/sidemask.svg" alt="Townesquare sidemask" />
          <div className="">
            <button
              onClick={() => setisEpochnOpen(!isEpochnOpen)}
              className="flex items-center justify-between w-[126px] h-[44px] px-8 py-6  -mt-6 gap-2 rounded-full border border-[#B882FF] text-sm font-medium bg-[#1a1a1a]"
            >
              <span className="text-white text-[15px]">Epoch</span>
              <span className="text-white bg-[#9264F8] rounded w-[20px] h-[20px]  pr-2 pl-2">
                1
              </span>
            </button>
          </div>

          {/* <img
                 className="w-auto h-auto my-8 cursor-pointer"
                 src="assets/main_v4/SideBar.svg"
                 onClick={() => {
                   setActiveTab("TownSquare NFT");
                   sessionStorage.setItem("ExplorerTab", "TownSquare NFT");
                 }}
                 alt="Sidebar"
               /> */}
          <Link to="/onboard/townesquare-nft">
            <img
              className="w-auto h-auto my-8 cursor-pointer"
              src="/assets/main_v4/sidelogoo.png"
              alt="Townesquare NFT"
            />
          </Link>

          <nav>
            <ul className="flex flex-col gap-[32px] text-sm font-bold">
              <li
                className={`flex items-center gap-3 cursor-pointer text-[15px] ${
                  tab === "ranking" ? "text-purple-400" : ""
                }`}
              >
                <Link to="/onboard/ranking" className="flex items-center gap-3">
                  <SvgRankComponent
                    fill={tab === "ranking" ? "#B882FF" : "white"}
                  />
                  Testnet Ranking
                </Link>
              </li>

              <li
                className={`flex items-center gap-3 cursor-pointer text-[15px] ${
                  tab === "explore-apps" ? "text-purple-400" : ""
                }`}
              >
                <Link
                  to="/onboard/explore-apps"
                  className="flex items-center gap-3"
                >
                  <SvgExploreComponent
                    fill={tab === "explore-apps" ? "#B882FF" : "white"}
                  />
                  Explore apps
                </Link>
              </li>

              {/* <li
                     className={`flex items-center gap-3 cursor-pointer text-[15px] ${
                       tab === "stake-earn" ? "text-purple-400" : ""
                     }`}
                   >
                     <Link
                       to="/onboard/stake-earn"
                       className="flex items-center gap-3"
                     >
                       <SvgStakeComponent
                         fill={tab === "stake-earn" ? "#B882FF" : "white"}
                       />
                       Stake & Earn
                     </Link>
                   </li> */}

              <li
                className={`flex items-center cursor-pointer gap-3 text-[15px] ${
                  tab === "townesquare-nft" ? "text-purple-400" : ""
                }`}
              >
                <Link
                  to="/onboard/townesquare-nft"
                  className="flex items-center gap-3"
                >
                  <link
                    rel="preload"
                    href="/assets/main_v4/DFNFT.svg"
                    as="image"
                  />
                  <link
                    rel="preload"
                    href="/assets/main_v4/RNNFT.svg"
                    as="image"
                  />
                  <img
                    src={
                      tab === "townesquare-nft"
                        ? "/assets/main_v4/DFNFT.svg"
                        : "/assets/main_v4/RNNFT.svg"
                    }
                    alt="NFT Icon"
                  />
                  TownSquare NFTs
                </Link>
              </li>

              <li
                className={`flex items-center gap-3 cursor-pointer text-[15px] ${
                  tab === "artist-spotlight" ? "text-purple-400" : ""
                }`}
              >
                <Link
                  to="/onboard/artist-spotlight"
                  className="flex items-center gap-3"
                >
                  <link
                    rel="preload"
                    href="/assets/main_v4/Ar.svg"
                    as="image"
                  />
                  <link
                    rel="preload"
                    href="/assets/main_v4/Articon.svg"
                    as="image"
                  />
                  <img
                    src={
                      tab === "artist-spotlight"
                        ? "/assets/main_v4/Ar.svg"
                        : "/assets/main_v4/Articon.svg"
                    }
                    className="w-6 h-6"
                    alt="aRT Icon"
                  />
                  Artist Spotlight
                </Link>
              </li>

              <li
                className={`flex items-center gap-3 cursor-pointer text-[15px] ${
                  tab === "townsquare-avatar" ? "text-purple-400" : "text-purple-400"
                }`}
              >
                <Link
                  to="/onboard/townsquare-avatar"
                  className="flex items-center gap-3"
                >
                  <link
                    rel="preload"
                    href="/assets/main_v4/Ar.svg"
                    as="image"
                  />
                  <link
                    rel="preload"
                    href="/assets/main_v4/Articon.svg"
                    as="image"
                  />
                  <img
                    src={
                      tab === "townsquare-avatar"
                        ? "/assets/main_v4/actAvatar.svg"
                        : "/assets/main_v4/actAvatar.svg"
                    }
                    className="w-6 h-6"
                    alt="aRT Icon"
                  />
                  TowneSquare Avatar
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </aside>

      {/* Main content */}
      <main className="flex-1 ml-0 md:ml-[244px]">
        <PrevHeader
          pubAddress={pubAddress}
          onDisconnect={disconnectWallet}
          onConnect={handleOConnect}
          title={"TowneSquare Avatar"}
        />
        <TownesquareMainAvatar />
      </main>

      {showLoginModal && <Tslogin onCancelProcess={handleOfConnect} />}
      {isEpochnOpen && <EpochFlow onCancelProcess={handleCloseModal} />}
    </div>
  );
};

export default LootboxPage;